import { FormControlLabel, Radio } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

interface IFormControl {
  value: string | number | boolean;
  label: string;
  fontWeight?: number;
  size?: string;
  sizeMobile?: string;
  invisible?: boolean;
}

const FControlLabel = ({ value, label, fontWeight = 700, size = '1.5rem', sizeMobile = '1rem', invisible } : IFormControl) => {
  const matches = useMediaQuery('(max-width:765px)');

  return (
    <FormControlLabel
      value={value}
      control={<Radio />}
      className={invisible ? 'invisible' : ''}
      sx={{
        '.MuiFormControlLabel-label': {
          fontWeight: fontWeight,
          fontSize: matches ? sizeMobile : size,
        },
      }}
      label={label}
    />
  );
};
export default FControlLabel;
